import { pageTitle } from '../styles/theme';

interface PageHeaderProps {
  title: string;
  isFetching?: boolean;
  /**
   * Optional total-item count rendered as a muted pill beside the title (e.g.
   * the number of sessions matching the active filters). Shown only when
   * defined, so pages that don't have a count are unaffected. Formatted with
   * locale grouping so large totals stay legible.
   */
  count?: number;
  children?: React.ReactNode;
}

export function PageHeader({ title, isFetching, count, children }: PageHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
      <div className="flex items-center gap-3">
        <h2 className={pageTitle}>{title}</h2>
        {count !== undefined && (
          <span className="inline-flex items-center rounded-full bg-navy-100 dark:bg-navy-700 px-2.5 py-0.5 text-sm font-medium text-navy-600 dark:text-navy-300">
            {count.toLocaleString()}
          </span>
        )}
        {isFetching && (
          <svg className="animate-spin h-4 w-4 text-navy-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        )}
      </div>
      {children && (
        <div className="flex items-center gap-2">
          {children}
        </div>
      )}
    </div>
  );
}
